import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postOidcConfigurationByCustomer } from '../../../../api';

export const adminOidcConfigurationsByCustomerByIdPostSlice = createPostAsyncSlice({
	name: 'AdminOidcConfigurationsByCustomerById',
	receive: true,
	request: true,
	requestHandler: postOidcConfigurationByCustomer,
	retainDataOnRequest: false
});
